import { storage } from '@carrent/platform'

/**
 * Токены доступа и идентификаторы клиента.
 *
 * Единственное место, где эти ключи называются по имени. Раньше строки
 * 'access_token' и 'refresh_token' были продублированы в authStore,
 * client.js и точках входа обоих приложений — четыре места, которые
 * обязаны были совпадать.
 */
const ACCESS = 'access_token'
const REFRESH = 'refresh_token'
const DEVICE = 'device_id'
const SESSION = 'session_id'

export const getAccessToken = () => storage.getRaw(ACCESS)
export const getRefreshToken = () => storage.getRaw(REFRESH)

export function setTokens(access, refresh) {
  storage.setRaw(ACCESS, access)
  if (refresh) storage.setRaw(REFRESH, refresh)
}

/**
 * Начать новую сессию входа.
 *
 * Вызывается при успешном логине. Идентификатор именно сессии входа,
 * а не вкладки: раньше он создавался лениво при первом же запросе —
 * то есть ещё на экране логина — и после входа не менялся. В результате
 * неуспешные попытки входа и последующая рабочая сессия склеивались
 * под одним идентификатором, и при разборе перебора пароля нельзя было
 * отделить попытки от того, что человек делал уже внутри.
 */
export function startSession() {
  const id = uuid()
  storage.setRaw(SESSION, id)
  return id
}

export function clearTokens() {
  storage.removeRaw(ACCESS)
  storage.removeRaw(REFRESH)
  // Сессия заканчивается вместе с токеном: следующий вход
  // получит новый идентификатор.
  storage.removeRaw(SESSION)
}

const uuid = () =>
  globalThis.crypto?.randomUUID?.() ??
  'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0
    return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16)
  })

/** Стабильный идентификатор устройства. Живёт между сессиями. */
export function getDeviceId() {
  let id = storage.getRaw(DEVICE)
  if (!id) {
    id = uuid()
    storage.setRaw(DEVICE, id)
  }
  return id
}

/**
 * Идентификатор текущей сессии.
 *
 * Живёт в localStorage рядом с токеном, а не в sessionStorage:
 * sessionStorage привязан к вкладке, и один вход в двух вкладках
 * давал два разных идентификатора — корреляция «что пользователь
 * делал за эту сессию» рассыпалась. Токен переживает закрытие вкладки,
 * значит и сессия должна.
 *
 * Если идентификатора нет (первый запрос до входа) — создаём временный:
 * он нужен, чтобы связать между собой попытки входа.
 */
export function getSessionId() {
  let id = storage.getRaw(SESSION)
  if (!id) {
    id = uuid()
    storage.setRaw(SESSION, id)
  }
  return id
}

export const newRequestId = uuid
